import styled from 'styled-components';
import {
    Button,
    Paper,
    Divider
  } from '@material-ui/core';

export const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
`;

export const LogoutButton = styled(Button)`
  && {
    border-radius: 30px;
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    font-weight: bold;
    padding: ${({ theme }) => theme.spacing * 2}px
        ${({ theme }) => theme.spacing * 8}px;
    }
`;

export const StyledDivider = styled(Divider)`
  && {
    margin: ${({ theme }) => theme.spacing * 2}px 0;
  }
`;

export const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing * 2}px;
`;

export const UserName = styled.h4`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray};
  margin: ${({ theme }) => theme.spacing * 2}px 0;
`;

export const DovePointsWrapper = styled.div`
  margin: 0 0 0 ${({ theme }) => theme.spacing * 2}px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > p {
    margin: 0;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    opacity: .87;
    color: #ffffff8a;
  }
`;

export const ListElement = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  margin: ${({ theme }) => theme.spacing * 2}px 0;
  cursor: pointer;
`;